import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Badge, Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon, Flag as FlagIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import AnswerReportCreate from './AnswerReportCreate';
import AnswerReportEdit from './AnswerReportEdit';
import apiProfileSlice from '../features/api/rest/apiProfileSlice';
import { useListAnswerAbuseReportsQuery } from '../features/api/rest/apiAnswersReportsSlice';

function AnswerReport({ questionId, answerId, owner }) {
  const { ean } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [showModal, setShowModal] = React.useState(false);
  const { data: fetchedReports } = useListAnswerAbuseReportsQuery({ ean, questionId, answerId });
  const { user } = apiProfileSlice.endpoints.getProfile.useQueryState(undefined, {
    selectFromResult: ({ currentData }) => ({
      user: currentData?.username,
    }),
  });

  const handleClick = () => {
    if (!fetchedReports || !user) {
      navigate('/login', { state: { next: `${location.pathname}${location.search}` } });
      return;
    }
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <>
      {user !== owner && (
        <Badge color="error" variant="dot" sx={{ position: 'absolute', bottom: 10, right: 10 }} invisible={!fetchedReports?.length > 0}>
          <FlagIcon sx={{ color: 'grey.400', cursor: 'pointer' }} onClick={handleClick} fontSize="small" />
        </Badge>
      )}
      <Dialog open={showModal} onClose={() => setShowModal(false)} maxWidth="lg" fullWidth>
        <DialogContent>
          {fetchedReports?.length !== 8 && (
            <Box>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {t('reports.create.heading', { what: 'answer' })}
              </Typography>
              <AnswerReportCreate questionId={questionId} answerId={answerId} />
            </Box>
          )}
          {fetchedReports?.length > 0 && (
            <Box>
              <Typography variant="h6" sx={{ mt: 2 }}>
                {t('reports.edit.heading')}
              </Typography>
              <AnswerReportEdit questionId={questionId} answerId={answerId} />
            </Box>
          )}
        </DialogContent>
        <IconButton onClick={handleCancel} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
      </Dialog>
    </>
  );
}

AnswerReport.propTypes = {
  answerId: PropTypes.number.isRequired,
  owner: PropTypes.string.isRequired,
  questionId: PropTypes.number.isRequired,
};

export default AnswerReport;
